import FilterWiFi from './FilterWiFi';

export default FilterWiFi;
